import React from 'react';

import { useCopyContext } from '../../context/CopyContext';
import { useApp } from '../../hooks';
import { ShareModal as WrappedShareModal } from './ShareModal';

export function ShareModal() {
  const { shareModal } = useCopyContext();
  const { hideModal } = useApp();

  return (
    <WrappedShareModal
      heading={shareModal.heading}
      description={shareModal.description}
      onClose={hideModal}
    />
  );
}
